export const removeEmptyValues = <T extends object>(object: T) => {
  return JSON.parse(JSON.stringify(object)) as Partial<T>;
};
